import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import client from 'api'

const initialState = {
    schemas: {} as any,
}

export const loadSchema = createAsyncThunk('schemas/loadSchema', async (name: string) => {
    const url = `api/ixweb/json_schema/?model_name=${name}`
    const res = await client.get(url)

    if (res.data.count !== 1) {
        // handle error
        throw Error(`Failed to load schema for '${name}'`)
    } else {
        return res.data.results[0]
    }
})

const schemasSlice = createSlice({
    name: 'schemas',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(loadSchema.pending, (state, action) => {
            const name = action.meta.arg
            state.schemas[name] = {
                status: 'pending',
                error: undefined,
                schema: null,
            }
        })

        builder.addCase(loadSchema.rejected, (state, action) => {
            const name = action.meta.arg
            state.schemas[name] = {
                ...state.schemas[name],
                status: 'rejected',
                error: action.error.message
            }
        })

        builder.addCase(loadSchema.fulfilled, (state, action) => {
            const name = action.meta.arg
            if (action.payload) {
                state.schemas[name] = {
                    status: 'fulfilled',
                    error: undefined,
                    schema: action.payload.schema
                }
            }
        })
    }
})

export default schemasSlice.reducer
